/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, DialogActions, Grid } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  createInspectionPutRequest,
  createInspectionsFormFields,
  createOrderInspectionSentRequest,
  createPostRequest,
  createVendorFormTab,
  createVendorInfoFormFields,
  createVendorInfoPutRequest,
  normalizeInspectionForForms
} from './FormFields/inspectionsFormFields';
import { createInspectionsFormTab } from './FormFields/inspectionsFormFields';
import {
  deleteInspection,
  getInspections,
  postInspection,
  updateInspection,
  updateInspectionState
} from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import { useInspectionsHandler } from './inspectionsApiHandler';
import EditableCard from 'modules/common/editableCard.component';
import InspectionsHeader from './inspectionsHeader';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import { getHomesaleInfo } from 'modules/authorizations/authorizations.actions';

const Inspections = props => {
  const { inspectors, brokers, authId, inspections, isReadOnly, enumerations, homesaleId, vendors } = props;

  const [selectedInspection, setSelectedInspection] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sendInspectionIsLoading, setSendInspectionIsLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const inspectionHandler = useInspectionsHandler(props);

  useEffect(() => {
    if (inspections?.length > 0 && !selectedInspection) {
      setSelectedInspection(inspections[inspections.length - 1]);
    }
  }, [inspections]);

  const handleOrderInspection = async () => {
    setSendInspectionIsLoading(true);
    let isSuccessful = false;
    const request = createOrderInspectionSentRequest(selectedInspection, authId);
    const currentId = selectedInspection?.homesaleInspectionId;
    const resp = await inspectionHandler.handleUpdateInspection(authId, homesaleId, currentId, request);
    if (resp) {
      isSuccessful = true;
      const refreshed = await inspectionHandler.handleGetInspection(authId, homesaleId);
      const same = (refreshed ?? []).find(x => x.homesaleInspectionId === currentId) ?? null;
      if (same) setSelectedInspection(same);
    }
    setSendInspectionIsLoading(false);
    return isSuccessful;
  };

  const createNewInspection = async values => {
    setIsLoading(true);
    let isSuccessful = false;
    const request = createPostRequest(values, authId, homesaleId);
    const resp = await inspectionHandler.handleCreateInspection(authId, homesaleId, request);
    if (resp) {
      const refreshed = await inspectionHandler.handleGetInspection(authId, homesaleId);
      const created = [...refreshed].sort((a, b) => (b.homesaleInspectionId ?? 0) - (a.homesaleInspectionId ?? 0))[0] ?? null;
      if (created) setSelectedInspection(created);
      isSuccessful = true;
    }
    setIsLoading(false);
    return isSuccessful;
  };
  const handleInspectionFormSubmission = async (tab, values) => {
    setIsLoading(true);
    let isSuccessful = false;
    const request = createInspectionPutRequest(selectedInspection, values, authId, homesaleId);
    const currentId = selectedInspection?.homesaleInspectionId;
    const resp = await inspectionHandler.handleUpdateInspection(authId, homesaleId, currentId, request);
    if (resp) {
      const refreshed = await inspectionHandler.handleGetInspection(authId, homesaleId);
      const same = (refreshed ?? []).find(x => x.homesaleInspectionId === currentId) ?? null;
      if (same) setSelectedInspection(same);
      isSuccessful = true;
      await props.getHomesaleInfo(authId);
    }
    setIsLoading(false);
    return isSuccessful;
  };

  const handleVendorInfoFormSubmission = async (tab, values) => {
    setIsLoading(true);
    let isSuccessful = false;
    const request = createVendorInfoPutRequest(selectedInspection, values, authId, homesaleId);
    const currentId = selectedInspection?.homesaleInspectionId;
    const resp = await inspectionHandler.handleUpdateInspection(authId, homesaleId, currentId, request);
    if (resp) {
      const refreshed = await inspectionHandler.handleGetInspection(authId, homesaleId);
      const same = (refreshed ?? []).find(x => x.homesaleInspectionId === currentId) ?? null;
      if (same) setSelectedInspection(same);
      isSuccessful = true;
      await props.getHomesaleInfo(authId);
    }
    setIsLoading(false);
    return isSuccessful;
  };

  const handleDeleteSelectedInspection = async () => {
    if (!selectedInspection) return null;
    setIsDeleteLoading(true);
    const currentId = selectedInspection.homesaleInspectionId;
    const currentIndex = inspections.findIndex(s => s.homesaleInspectionId === currentId);
    const resp = await inspectionHandler.handleDeleteInspection(authId, homesaleId, currentId);
    const refreshed = await inspectionHandler.handleGetInspection(authId, homesaleId);
    const list = refreshed ?? [];
    await props.getHomesaleInfo(authId);
    if (list.length > 0) {
      const nextIndex = Math.min(currentIndex, list.length - 1);
      setSelectedInspection(list[nextIndex]);
    } else {
      setSelectedInspection(null);
    }

    setIsDeleteLoading(false);
    return resp;
  };

  const SendInspectionButton = ({ ...rest }) => {
    let buttonText = selectedInspection?.isInspectionSent === true ? 'Re-order Inspection' : 'Order Inspection';

    return (
      <>
        {sendInspectionIsLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            <DialogActions sx={{ p: '1.25rem' }}>
              <Spinner />
            </DialogActions>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '20px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 10px'
              }}
            >
              {' '}
              {!isReadOnly && (
                <Button
                  onClick={handleOrderInspection}
                  color="secondary"
                  variant="contained"
                  sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                >
                  {buttonText}
                </Button>
              )}
            </Box>
          </Box>
        )}
      </>
    );
  };

  return (
    <>
      {isDeleteLoading ? (
        <Spinner />
      ) : (
        <>
          <InspectionsHeader
            inspections={inspections}
            inspectors={inspectors}
            createNewInspectionFunc={createNewInspection}
            isLoading={isLoading}
            selectedInspection={selectedInspection}
            setSelectedInspection={setSelectedInspection}
            handleDeleteSelectedInspection={handleDeleteSelectedInspection}
            handleOrderInspection={handleOrderInspection}
            isReadOnly={isReadOnly}
            enumerations={enumerations}
            vendors={vendors}
          />
          {(inspections?.length ?? 0) === 0 ? (
            <div />
          ) : (
            <Box sx={{ paddingTop: '10px' }}>
              <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                <Grid item xs={12} xl={8}>
                  <EditableCard
                    tabs={createInspectionsFormTab()}
                    summaries={createInspectionsFormFields(normalizeInspectionForForms(selectedInspection), enumerations)}
                    updateFields={handleInspectionFormSubmission}
                    isLoading={isLoading}
                    numColumns={5}
                    ButtonComponent={SendInspectionButton}
                    hideEdit={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} xl={4}>
                  <EditableCard
                    tabs={createVendorFormTab()}
                    summaries={createVendorInfoFormFields(normalizeInspectionForForms(selectedInspection), brokers, inspectors, vendors)}
                    updateFields={handleVendorInfoFormSubmission}
                    isLoading={isLoading}
                    hideEdit={isReadOnly}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </>
      )}
    </>
  );
};

Inspections.propTypes = {
  inspectors: PropTypes.array.isRequired,
  brokers: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  vendors: PropTypes.array.isRequired,
  inspections: PropTypes.array
};

export default compose(
  connect(null, {
    getInspections,
    postInspection,
    updateInspection,
    deleteInspection,
    updateInspectionState,
    showToast,
    getHomesaleInfo
  })
)(Inspections);
